import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, OnDestroy, ViewChild } from '@angular/core';
import { RouterOutlet, Router, NavigationEnd } from '@angular/router';
import { FlyerPopupComponent } from '@shared/components/flyer-popup/flyer-popup.component';
// import { AmbassadorOnboardingFlowComponent } from './profiles/features/ambassador-onboarding/ambassador-onboarding-flow.component';
import { IdentityValidationFlowComponent } from '@shared/components/modal/identity-validation-modal/identity-validation-flow.component';
import { ModalNotifyComponent } from '@shared/components/modal/modal-notify/modal-notify.component';
import { NotifyPayload, NotifyService } from '@shared/services/notify/notify.service';
import { SharedDataService } from '@shared/services/sharedData/shared-data.service';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { ChatButtonComponent } from '@shared/components/chat-button/chat-button.component';
import { ChatbotService } from '@shared/services/chatbot/chatbot.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    ModalNotifyComponent,
    CommonModule,
    FlyerPopupComponent,
    // AmbassadorOnboardingFlowComponent, // Onboarding desactivado temporalmente.
    IdentityValidationFlowComponent,
    ChatButtonComponent
  ],
  providers: [],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements AfterViewInit, OnDestroy {
  @ViewChild(FlyerPopupComponent) private readonly flyerPopup?: FlyerPopupComponent;
  // @ViewChild(AmbassadorOnboardingFlowComponent) private readonly onboardingFlow?: AmbassadorOnboardingFlowComponent;
  @ViewChild(IdentityValidationFlowComponent) private readonly onboardingFlow?: IdentityValidationFlowComponent;

  title = 'BO-FRONT';
  notify: NotifyPayload | null = null;
  showChatButton = false;

  private readonly subscriptions = new Subscription();

  constructor(
    private readonly notifyService: NotifyService,
    private readonly sharedDataService: SharedDataService,
    private readonly router: Router,
    private readonly chatbotService: ChatbotService
  ) {
    this.subscriptions.add(
      this.notifyService.notify$.subscribe((payload) => {
        this.notify = payload;
      })
    );

    this.subscriptions.add(
      this.router.events.pipe(
        filter(event => event instanceof NavigationEnd)
      ).subscribe((event: any) => {
        const url = event.urlAfterRedirects || event.url;
        const hasSession = !!localStorage.getItem('user_info');
        const isProfileRoute = url.includes('/profile');
        const isChatSocio = url.includes('/chat-socio');
        const isExcludedRoute =
          url.includes('/login') ||
          url.includes('/auth') ||
          url.includes('/forgot-password') ||
          url.includes('/guest') ||
          url.includes('/checkout') ||
          url.includes('/home') ||
          url === '/';

        this.showChatButton = hasSession && isProfileRoute && !isChatSocio && !isExcludedRoute;
        
        // El websocket arranca solito porque el chatbotService se inyecta aqui, 
        // y su constructor escucha a userInfo$.
        // No desconectamos al ocultar el boton para mantener persistencia si navega.
      })
    );
  }

  ngAfterViewInit(): void {
    this.subscriptions.add(
      this.sharedDataService.fromLogin$.subscribe((fromLogin) => {
        if (!fromLogin) return;

        this.onboardingFlow?.onMarketingFlyerLoadStarted();
        this.flyerPopup?.loadFlyers();
        this.sharedDataService.setFromLogin(false);
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  closeNotify(): void {
    this.notify = null;
    this.notifyService.clear();
  }
}
